import { styled } from "@mui/material";

import { Row } from "../layout";

export const Header = styled(Row)({
  justifyContent: "space-between",
});

export const TooltipWrapper = styled(Row)(({ theme }) => ({
  gap: theme.spacing(1),
}));
